jQuery(document).ready(function ($) {
  const placeId = 'ChIJ39iS6esJxkcRN4AZNpSrR5A';
  const maxReviews = 12;

  if (document.querySelector('#google-reviews-container')) {
    const script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDrhFh1HT9Yd-v3y450YbPmigY89no_-Aw&libraries=places';
    script.async = true;
    script.defer = true;
    script.onload = function () {
      fetchGoogleReviews();
    };
    document.head.appendChild(script);
  } else {
    console.log('Google Reviews container not found, skipping API load.');
  }

  function fetchGoogleReviews() {
    if (typeof google === 'undefined') {
      console.error('Google Maps API não está carregada.');
      return;
    }

    const service = new google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails(
      {
        placeId: placeId,
        fields: ['reviews', 'rating', 'user_ratings_total'],
      },
      (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          if (place.reviews) {
            populateReviews(place.reviews);
          }
          if (place.rating && place.user_ratings_total) {
            $('.testimonials-rating-value').text(place.rating);
            $('.testimonials-rating-count').text(place.user_ratings_total);
          }
        } else {
          console.error('Erro ao carregar as avaliações do Google.');
        }
      }
    );
  }

  function populateReviews(reviews) {
    const container = $('#google-reviews-container');
    container.empty();

    const reviewLink = `https://search.google.com/local/reviews?placeid=${placeId}`;

    // Filter reviews to show only 5-star reviews and sort them by date (newest first)
    const fiveStarReviews = reviews
      .filter((review) => review.rating === 5)
      .sort((a, b) => b.time - a.time);

    fiveStarReviews.slice(0, maxReviews).forEach((review) => {
      const ratingStars = Array(review.rating)
        .fill('<li class="list-inline-item"><i class="fa-solid fa-star"></i></li>')
        .join('');

      const dateObj = new Date(review.time * 1000);
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;

      const reviewItem = `
        <div class="item">
          <a href="${reviewLink}" target="_blank" rel="noopener noreferrer" class="review-link">
            <div class="card card-testimonials text-center border-0">
              <img
                loading="lazy"
                src="${review.profile_photo_url || 'https://via.placeholder.com/100'}"
                alt="${review.author_name}"
              >
              <div class="card-body">
                <h4 class="card-title">${review.author_name}</h4>
                <p class="date-post">${formattedDate}</p>
                <ul class="list-inline">${ratingStars}</ul>
                <p class="card-text">"${review.text}"</p>
              </div>
            </div>
          </a>
        </div>`;
      container.append(reviewItem);
    });

    container.owlCarousel({
      loop: true,
      margin: 15,
      lazyLoad: true,
      responsiveClass: true,
      autoplayHoverPause: true,
      dots: false,
      nav: true,
      responsive: {
        0: {
          items: 1,
          nav: true,
          dots: false,
        },
        600: {
          items: 2,
          nav: true,
        },
        1000: {
          items: 4,
          nav: true,
          autoplay: false,
          loop: true,
        },
      },
    });
  }
});
